const styles = theme => ({
  integrationsBoxContainer: {
    padding: theme.spacing(2)
  },
  networkTitle: {
    textTransform: "unset",
    color: theme.palette.primary.default
  },
  icon: {
    width: 40,
    height: 40
  },
  intItem: {
    paddingBottom: theme.spacing(4)
  },
  rightContainer: {
    width: "40%",
    [theme.breakpoints.down("md")]: {
      width: "100%"
    }
  },
  leftContainer: {
    width: "60%",
    [theme.breakpoints.down("md")]: {
      width: "100%"
    }
  },

  actionButton: {
    width: 300,
    height: 36,
    // borderRadius: 2,
    fontSize: 14,
    fontWeight: 700,
    backgroundColor: theme.palette.primary.main,
    textAlign: "center",
    color: theme.palette.secondary.light,
    justifyContent: "space-around",
    textTransform: "unset",
    "&:hover": {
      backgroundColor: theme.palette.primary.main
    },
    marginTop: theme.spacing(2)
  },

  buttonDisconnect: {
    height: 36,
    color: [theme.palette.warning.main, "!important"],
    opacity: "0.7",
    maxWidth: 300,
    fontFamily: "Poppins",
    textAlign: "center",
    fontSize: 14,
    fontWeight: 700,
    textTransform: "unset"
  },
  moreContainer: {
    width: "100%"
  },
  networkContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  noPlatformsConnected: {
    color: theme.palette.primary.default,
    marginBottom: theme.spacing(2)
  },

  connectedPages: {
    color: theme.palette.primary.default
  },

  userAccount: {
    color: theme.palette.primary.default,
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(2)
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Settings/IntegrationConnections/styles.js